var _circle, _circle2, _circle3, _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 178,
    viewBox: "0 0 178 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 89,
    cy: 89,
    r: 89,
    fill: "#00BD59"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 89,
    cy: 89,
    r: 74,
    fill: "#00BD59"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 89,
    cy: 89,
    r: 59,
    fill: "#00BD59"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 45,
    width: 88,
    height: 88,
    rx: 44,
    fill: "#00BD59"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_265_3316",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 65,
    width: 48,
    height: 48
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 65,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_265_3316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.9 95.1L101.4 77.65C101.879 77.1833 102.448 76.95 103.109 76.95C103.77 76.95 104.333 77.1842 104.8 77.6525C105.267 78.1212 105.5 78.6845 105.5 79.3425C105.5 80.0008 105.267 80.57 104.8 81.05L85.6 100.2C85.1213 100.667 84.5517 100.9 83.891 100.9C83.2303 100.9 82.6667 100.667 82.2 100.2L73.2 91.2C72.7333 90.7177 72.5 90.1472 72.5 89.4885C72.5 88.8295 72.7342 88.2667 73.2025 87.8C73.6712 87.3333 74.2345 87.1 74.8925 87.1C75.5508 87.1 76.12 87.3333 76.6 87.8L83.9 95.1Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success-check.d45f32c966c3b6c99888dbe622da738d.svg";
export { ForwardRef as ReactComponent };